import { connect } from 'react-redux'
import Component from 'components/Suppliers/Select/Filter'

export default connect()(Component)
